import { useEffect, useState } from 'react';

const SLIDES = ['/head1.jpg', '/head2.jpg', '/head3.jpg'];
const SLIDE_MS = 7000;

/** Cross-fading header slideshow (replaces the original jQuery panz2.js). */
export function Panz() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((i) => (i + 1) % SLIDES.length);
    }, SLIDE_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="panz" aria-hidden="true">
      {SLIDES.map((src, i) => (
        <div key={src} className={`panz-slide${i === active ? ' is-active' : ''}`}>
          <img src={src} alt="" />
        </div>
      ))}
    </div>
  );
}
